function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "Filled_outline",
  "data-name": "Filled outline"
}, /*#__PURE__*/React.createElement("path", {
  d: "m3 3h58v58h-58z",
  fill: "#32b1cc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m8 8h48v48h-48z",
  fill: "#87cee9"
}), /*#__PURE__*/React.createElement("path", {
  d: "m61 2h-58a1 1 0 0 0 -1 1v58a1 1 0 0 0 1 1h58a1 1 0 0 0 1-1v-58a1 1 0 0 0 -1-1zm-1 58h-56v-56h56z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m30 30a1 1 0 0 0 1 1h8v-2h-7v-21h11v4h2v-4h11v21h2v-22a1 1 0 0 0 -1-1h-51v2h24z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m52 29v-6h-7v-5h7v-6h-2v4h-7v7h-5v-11h-2v12a1 1 0 0 0 1 1h6v10h-10a1 1 0 0 0 -1 1v4h-6v-8a1 1 0 0 0 -1-1h-11v-9h4a1 1 0 0 0 1-1v-7h5v11h-6v2h7a1 1 0 0 0 1-1v-13a1 1 0 0 0 -1-1h-7a1 1 0 0 0 -1 1v7h-4a1 1 0 0 0 -1 1v15h2v-3h10v8a1 1 0 0 0 1 1h7v10h2v-15h10a1 1 0 0 0 1-1v-11h5v4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7 58h50a1 1 0 0 0 1-1v-21a1 1 0 0 0 -1-1h-6a1 1 0 0 0 -1 1v5h-10a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h10v3h2v-4a1 1 0 0 0 -1-1h-10v-4h11v-6h4v19h-14v-4h-2v4h-13v-9a1 1 0 0 0 -1-1h-6v-7a1 1 0 0 0 -1-1h-4v2h3v6h-5a1 1 0 0 0 -1 1v5h2v-4h11v8h-17v-40h5v-2h-7v43a1 1 0 0 0 1 1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6 10h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10 10h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m56 31h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m52 31h2v2h-2z"
}));

const SvgMaze = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  height: 512,
  viewBox: "0 0 64 64",
  width: 512,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMaze, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/maze.261cf2b4.svg";
export { ForwardRef as ReactComponent };